export default __webpack_public_path__ + "static/media/pro-elevate-lav-2.444e7f3a.png";